import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { BrokerService } from '@c4/core';

import { Device } from '../../../common/interfaces/item.interface';
import { Command } from '../../../common/params/interfaces/command.interface';
import { Event } from './../../../common/interfaces/event.interface';
import { ProgrammingUtilsService as Util } from '../../../common/services/utils.service';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';
import { SharedProgrammingService, CommonProgrammingContext } from '../../../common/services/shared-programming.service';

import { ThermostatProgrammingContext, QSThermostatService } from '../quickstart-thermostats.service';

const COMMAND_WHITELIST = ["SET_PRESET"];

@Component({
  templateUrl: './select-action.component.html',
  styleUrls: [
    './select-action.component.less'
  ]
})
export class QSThermostatSelectActionComponent extends BaseRoutingComponent {

  private _thermostat: Observable<Device>;
  private _commands: Observable<Command[]>;

  constructor(
    private _route: ActivatedRoute,
    protected store: Store<{
      thermostatProgramming: ThermostatProgrammingContext,
      sharedProgramming: CommonProgrammingContext
    }>,
    private _broker: BrokerService,
    public router: Router,
    private _shared: SharedProgrammingService,
    private _service: QSThermostatService
  ) {
    super();

    this._thermostat = Observable.combineLatest(
      this._route.params.map((params: { id: string }) => parseInt(params.id)),
      this.store.select(s => s.thermostatProgramming.thermostats).filter(t => !!t),
      (id, thermostats) => thermostats.find(t => t.id == id)
    );

    this._commands = this._thermostat
      .filter(t => !!t)
      .flatMap(thermostat => Observable.fromPromise(this._broker.call({
        path: `/api/v1/items/${thermostat.id}/commands`,
        queryString: {
          query: {
            command: {
              '$in': COMMAND_WHITELIST
            }
          }
        }
      })));

  }

  selectCommand(command: Command) {
    if (!!command.params && command.params.length > 0) {
      this.router.navigate(['../' + command.deviceId, command.command], {
        relativeTo: this._route
      });
    } else {
      this._shared.saveAction(command);
    }
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-thermostats/select-action/select-action.component.ts